<template>
  <div v-on:click="scrollToTop">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
    <g>
      <circle fill="#FCB016" cx="20.001" cy="20" r="20"/>
      <g>
        <path fill="#FFFFFF" d="M9.186,18.063c-0.275,0-0.55-0.108-0.755-0.323c-0.398-0.417-0.384-1.078,0.033-1.477L19.279,5.919    c0.402-0.387,1.041-0.387,1.443,0l10.814,10.345c0.417,0.399,0.432,1.06,0.033,1.477c-0.398,0.417-1.06,0.432-1.477,0.033    L20.001,8.12L9.907,17.773C9.705,17.967,9.445,18.063,9.186,18.063z"/>
        <g>
          <path fill="#FFFFFF" d="M11.075,22.101H8.223v-1.029h6.943v1.029H12.3v8.35h-1.225V22.101z"/>
          <path fill="#FFFFFF" d="M23.849,25.663c0,3.229-1.962,4.94-4.355,4.94c-2.478,0-4.217-1.921-4.217-4.76     c0-2.978,1.851-4.926,4.355-4.926C22.192,20.918,23.849,22.88,23.849,25.663z M16.57,25.816c0,2.004,1.086,3.799,2.992,3.799     c1.92,0,3.006-1.768,3.006-3.896c0-1.864-0.975-3.813-2.992-3.813C17.572,21.905,16.57,23.757,16.57,25.816z"/>
          <path fill="#FFFFFF" d="M25.419,21.183c0.585-0.098,1.35-0.182,2.324-0.182c1.196,0,2.073,0.278,2.63,0.779     c0.515,0.445,0.821,1.127,0.821,1.963c0,0.849-0.251,1.517-0.724,2.004c-0.641,0.682-1.684,1.029-2.867,1.029     c-0.361,0-0.695-0.014-0.974-0.084v3.758h-1.211V21.183z M26.63,25.705c0.265,0.069,0.599,0.097,1.002,0.097     c1.461,0,2.352-0.709,2.352-2.004c0-1.238-0.877-1.836-2.213-1.836c-0.528,0-0.933,0.041-1.141,0.097V25.705z"/>
        </g>
      </g>
    </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'ToTopButton',

    methods: {
      scrollToTop: function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }
</script>

<style lang="scss" scoped>

    svg {
      cursor: pointer;

      circle {
        transition: all .25s ease;
      }

      &:hover {
        circle {
          fill: #fdc045;
        }
      }
  }
</style>
